import Image from "next/image";
import { useContext, useEffect, useState } from "react";
import logoImage from "../../../../../public/images/logo.png";
import AppContext from "../../../../services/app-context-services";
import { ROUTES } from "../../../../services/router-services";
import { isNumeric, _, _c } from "../../../../services/text-services";
import Spinner from "../../../shared/spinner/spinner.component";
import Icibs from "../individual-character-input-boxes/icibs.component";
// @ts-ignore 
import telImage from "../../../../../shared-assets/icons/tel2.png";
import Button from "../../../../components/button/button";
import styles from "./login2.component.module.scss";

interface VerifyStepProps {
  container: "page" | "modal";
  setPinNumber: (pin: string) => void;
  isLoading: boolean;
  errorMessage?: string;
}

function VerifyStep2({ setPinNumber, container, isLoading, errorMessage }: VerifyStepProps) {
  const [countDown, setCountDown] = useState(59);
  const [phoneStr, setPhoneStr] = useState("");

  const { phoneMoment, isIntlUser } = useContext(AppContext);
  const PIN_LENGTH = 5;
  const logoScale = 1.10;

  const title = `کد ۵ رقمی ارسال شده به شماره ${_(phoneStr)} را وارد کنید`;
  const deltaTime = (timeNow: number, moment: number) =>
    Math.floor(moment / 1000 + 60 - timeNow / 1000);
  const isValidCountDown = (cd: number) => 0 <= cd && cd <= 60;

  const isValidPin = (pin: string) => isNumeric(pin) && pin.length === PIN_LENGTH

  function finalSubmitStep(pin: string) {
    if (!isValidPin(pin)) return;
    setPinNumber(pin);
  }

  useEffect(() => {
    const [localPhoneStr, localMomentStr] = phoneMoment.split("::");
    setPhoneStr(localPhoneStr);
    const isvalidcountdown = isValidCountDown(
      deltaTime(Date.now(), +localMomentStr)
    );
    if (isvalidcountdown) {
      const interval = setInterval(() => {
        setCountDown(deltaTime(Date.now(), +localMomentStr));
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [phoneMoment]);

  const counterContent = _(countDown + " : ۰۰");

  return (
    <div className={`container bg ${styles.wrapper} ${styles[container]}`}>
      <Image src={logoImage} width={200 * logoScale} height={44 * logoScale} />
      <p className={_c(styles, "secondary-heading verification")}>{title}</p>
      {errorMessage && <p className={_c(styles, "error-message")}>{errorMessage}</p>}
      <form className={_c(styles, "varify-form")}>
        <Icibs setOutput={output => finalSubmitStep(output)} />
        {!isLoading && <div className={_c(styles, "action-btn-container verification")}>
          <Button
            type="fill"
            buttonType="submit"
            size="fullWidth"
            text="ورود"
            customstyle={{
              boxShadow: "0px 4px 8px rgba(74, 87, 131, 0.16)",
            }}
          />
        </div>}

        <div className={_c(styles, "support-links-container verification")}>
          <Button
            type="ghost"
            size="small"
            text="اصلاح شماره موبایل"
            customstyle={{ padding: "0" }}
            onClick={() => setPinNumber("modify-phone-number" + Math.random())}
          />
          {!isIntlUser && <Button
            type="ghost"
            size="small"
            color="info"
            text="پشتیبانی"
            href={ROUTES.contactUs}
            customstyle={{ padding: "0" }}
            icon={{
              alt: "tel",
              path: telImage.src,
              order: "before",
            }}
          />}
        </div>
        {countDown && isValidCountDown(countDown) && (
          <p className={_c(styles, "counter")}>{counterContent}</p>
        )}
        {!isValidCountDown(countDown) && (
          <div className={_c(styles, "btn-retry")}>
            <Button
              text="ارسال مجدد کد تایید"
              size="small"
              type="ghost"
              color="info"
              onClick={() => {
                // inputEl.current.focus();
                setPinNumber("resend-pin-code" + Math.random());
              }}
              disabled={isValidCountDown(countDown)}
              customstyle={{ padding: "0" }}
            />
          </div>
        )}
        {isLoading && <div className={_c(styles, "spinner-container")}><Spinner type="tiny" /></div>}


      </form>
    </div>
  );
}

export default VerifyStep2;
